'use strict';

var formValidation = require('base/components/formValidation');
const baseLogin = require('base/login/login');

const { queryFirst, addClass, removeClass, loadInput, queryAll, validateDate, hasClass } = require('../domUtil');
const { formatPhoneNumber, getItemFromLocalStorage } = require('../util');
const { clearForm } = require('../clientSideValidation').functions;
const registrationFormPhone = queryFirst('.registration-form-phone');
const loyaltyGuestReferralModal = queryFirst('#loyalty-referral');
const $body = $('body');
const fullLoginPage = queryFirst('.login-page-container');
const loginPageNav = queryFirst('.login-nav-container');
const accountSheet = queryFirst('#account-sheet');
const loginHeaderLink = queryFirst('.login-item.dropdown-item');
const orderStatusHeaderLink = queryFirst('.order-status-item.dropdown-item');
const checkoutContainer = queryFirst('#checkout-main');
const pdpContainer = queryFirst('.pdp.container');
const mobileHeaderCloseBtn = queryFirst('.navbar > .close-menu > .close-button');
const { HIDDEN_CLASS, ACTIVE_CLASS } = require('../constants');
const { loadSheetData, clearSheet } = require('../helpers/accountSheetAjaxHelper');
const LOGIN_PAGE = 'login';
const REGISTER_PAGE = 'register';
const RESET_PASSWORD_PAGE = 'password-reset';
const RESET_PASSWORD_CONFIRM_PAGE = 'password-reset-confirm';
const TRACK_ORDER_PAGE = 'track-order';
const EXISTING_CUSTOMER_PAGE = 'existing-customer';
let PREVIOUS_PAGE = LOGIN_PAGE;

window.addEventListener('load', () => {
    validateDate();
    const formElement = queryFirst('.change-password-form');
    const referrerID = getItemFromLocalStorage('REFERRED_ID');

    if (fullLoginPage) {
        if (queryFirst('#login-form.active', fullLoginPage)) {
            addClass(loginHeaderLink, HIDDEN_CLASS);
        } else if (queryFirst('#order-form.active', fullLoginPage)) {
            addClass(orderStatusHeaderLink, HIDDEN_CLASS);
        }
    }
    if (referrerID && formElement) {
        loadInput(referrerID, formElement);
    }
    if (loyaltyGuestReferralModal) {
        $(loyaltyGuestReferralModal).modal('show');
    }
    if (checkoutContainer) {
        const guestCheckoutSignInModal = queryFirst('#guest-checkout-login');
        const cancelBtnRegistrationModal = queryFirst('.registration-right .cancel a', guestCheckoutSignInModal);
        if (cancelBtnRegistrationModal) {
            cancelBtnRegistrationModal.addEventListener('click', e => {
                e.preventDefault();
                $(guestCheckoutSignInModal).modal('hide');
            });
        }
        if (guestCheckoutSignInModal) {
            addClass(queryFirst('.account-need-help'), HIDDEN_CLASS);
            const registerLeft = queryFirst('.registration-left');
            const registerRight = queryFirst('.registration-right');
            removeClass(registerLeft, 'offset-md-2');
            addClass([registerLeft, registerRight], 'col-md-6');
        }
    }
});

/**
 * Enables the login button - to be called after this script loads to prevent early login button clicks.
 */
function enableLoginButton() {
    $body.off('login:dialogLoaded').on('login:dialogLoaded', () => {
        enableLoginButton();
    });

    const loginBtns = queryAll('.account-login-btn');
    if (loginBtns.length) {
        loginBtns.forEach(btn => (btn.disabled = false));
    }
}

/**
 * Switches the active page contained within the Login Sheet to the specified page
 * @param {string} page - Name of sheet page to switch to
 */
function setActivePage(page) {
    const activePage = queryFirst('.sheet-page.active', accountSheet);
    const activeForm = activePage && queryFirst('form', activePage);

    if (activePage) {
        activeForm?.reset();
        clearForm(activeForm);
        removeClass(activePage, ACTIVE_CLASS);
    }

    const nextPage = queryFirst(`.sheet-page.${page}-sheet`, accountSheet);
    addClass(nextPage, ACTIVE_CLASS);

    // chose where to focus:
    const preferred =
        queryFirst('[autofocus]', nextPage) ||
        queryFirst('input:not([disabled]):not([type="hidden"])', nextPage) ||
        queryFirst('button:not([disabled])', nextPage) ||
        queryFirst('a[href]', nextPage) ||
        nextPage; // fallback

    // focus:
    requestAnimationFrame(() => {
        try { preferred.focus({ preventScroll: true }); } catch { preferred.focus(); }
    });
}

/**
 * Opens the Login Sheet to the specified page
 * @param {string} page - Name of page that should be visible when the sheet opens
 */
function openSheet(page) {
    mobileHeaderCloseBtn?.click(); // Close Mobile Menu

    const $sheet = $(accountSheet);
    const isOpen = $sheet.hasClass('show');

    if (!isOpen) {
        $('.modal.show')
            .not('#account-sheet, #minicart, #stylitics-custom-quickview')
            .modal('hide');

        setActivePage(page);

        // set opener ONLY when outside accountSheet
        const activeEl = document.activeElement;
        const insideSheet = accountSheet.contains(activeEl);

        if (!insideSheet) {
            $sheet.data('opener', activeEl);
        }

        $sheet.modal('show');
    } else {
        setActivePage(page);
    }
}

module.exports = {
    ...baseLogin,

    login: function () {
        $body.on('submit', 'form.login', (e) => {
            const $sheet = $('.sheet.show .sheet-dialog');
            var form = $(e.target);
            e.preventDefault();
            var url = form.attr('action');
            $sheet.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                        $sheet.spinner().stop();
                        $('form.login').trigger('login:error', data);
                    } else {
                        // Store Stylitics Product ID in session storage to open mini-tote recommended product tile after successful login
                        // When user comes from Stylitics mini-tote widget
                        const styliticsWidgetElement = queryFirst('#styliticsWidgetProductId', accountSheet);
                        const { value: styliticsProductId } = styliticsWidgetElement?.dataset || {};
                        if (styliticsProductId) {
                            const { sessionStorage } = window;
                            sessionStorage.setItem('triggerMiniTote', true);
                            sessionStorage.setItem('styliticsMiniToteProductID', styliticsProductId);
                        }
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        $sheet.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $body.on('submit', 'form.registration', (e) => {
            const $sheet = $('.sheet.show .sheet-dialog');
            var form = $(e.target);
            e.preventDefault();
            var url = form.attr('action');
            $sheet.spinner().start();
            form.trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        // Store Stylitics Product ID in session storage to open mini-tote recommended product tile after success registration
                        // When user comes from Stylitics mini-tote widget
                        const styliticsWidgetElement = queryFirst('#styliticsWidgetProductId', accountSheet);
                        const { value: styliticsProductId } = styliticsWidgetElement?.dataset || {};
                        if (styliticsProductId) {
                            const { sessionStorage } = window;
                            sessionStorage.setItem('triggerMiniTote', true);
                            sessionStorage.setItem('styliticsMiniToteProductID', styliticsProductId);
                        }
                        form.trigger('register:success');
                        if (checkoutContainer || pdpContainer) {
                            // reloading the page when account is created from checkout page
                            location.reload();
                        } else {
                            // redirecting to my account when account is created from anywhere else
                            location.href = data.redirectUrl;
                        }
                    } else {
                        formValidation(form, data);
                        $sheet.spinner().stop();
                        form.trigger('register:error');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    $sheet.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        const $sheet = $('.sheet.show .sheet-dialog');
        $body.on('submit', '.reset-password-form', (e) => {
            const $resetPasswordForm = $('.reset-password-form');
            const form = $(e.target);
            e.preventDefault();
            const url = form.attr('action');
            $sheet.spinner().start();
            $resetPasswordForm.trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    $sheet.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        setActivePage(RESET_PASSWORD_CONFIRM_PAGE);
                    }
                },
                error: function () {
                    $sheet.spinner().stop();
                    accountSheet.modal('hide').one('hidden.bs.modal', () => {
                        $body.trigger('csrf:error');
                    });
                }
            });

            return false;
        });
    },
    handleLogin: () => {
        const loginBtnEl = queryFirst('.account-login-btn');
        const $loginFormEl = $('form.login');
        $loginFormEl.on('login:submit', () => {
            loginBtnEl.disabled = true;
        });

        $loginFormEl.on('login:error', () => {
            loginBtnEl.disabled = false;
        });
    },
    loginNavEvents: () => {
        loginPageNav?.addEventListener('click', e => {
            const { target } = e;
            if (hasClass(target, 'js-login-select')) {
                addClass(loginHeaderLink, HIDDEN_CLASS);
                removeClass(orderStatusHeaderLink, HIDDEN_CLASS);
            } else if (hasClass(target, 'js-order-select')) {
                removeClass(loginHeaderLink, HIDDEN_CLASS);
                addClass(orderStatusHeaderLink, HIDDEN_CLASS);
            } else {
                removeClass(loginHeaderLink, HIDDEN_CLASS);
                removeClass(orderStatusHeaderLink, HIDDEN_CLASS);
            }

            if (target instanceof HTMLAnchorElement && !hasClass(target, ACTIVE_CLASS)) {
                const activePage = queryFirst(`.${ACTIVE_CLASS}`, fullLoginPage);
                const activeForm = queryFirst('form', activePage);
                activeForm?.reset();
                clearForm(activeForm);
                addClass(queryFirst('.custom-error-alert', activeForm), HIDDEN_CLASS);
            }
        });
    },
    sheetEvents: () => {
        // Login click event
        $body.on('click', '.js-login-link', async (e) => {
            e.preventDefault();
            const el = e.currentTarget;
            const styliticsContainer = el.closest('.js-stylitics-product-data');
            const { styliticsProductId } = styliticsContainer?.dataset || {};
            const modalBody = queryFirst('.js-account-sheet-container', accountSheet);
            const miniCart = queryFirst('#minicart');
            const isMiniCartOpened = !!miniCart && hasClass(miniCart, 'show');
            if (!fullLoginPage) {
                await loadSheetData();
                openSheet(LOGIN_PAGE);
                enableLoginButton();
            } else {
                const loginNavTab = queryFirst('.js-login-select', loginPageNav);
                loginNavTab?.click();
            }
            // Handle Login from Stylitics Widget Product Tile
            if (isMiniCartOpened && styliticsProductId && modalBody) {
                const styliticsElement = document.createElement('div');
                styliticsElement.id = 'styliticsWidgetProductId';
                styliticsElement.dataset.value = styliticsProductId;
                modalBody.appendChild(styliticsElement);
            }
        });

        $body.on('click', '#myaccount', e => {
            e.preventDefault();
        });

        // Register click event
        $body.on('click', '.js-register-link', async e => {
            e.preventDefault();
            const el = e.currentTarget;
            const styliticsContainer = el.closest('.js-stylitics-product-data');
            const { styliticsProductId } = styliticsContainer?.dataset || {};
            const modalBody = queryFirst('.js-account-sheet-container', accountSheet);
            const miniCart = queryFirst('#minicart');
            const isMiniCartOpened = !!miniCart && hasClass(miniCart, 'show');

            if (!fullLoginPage) {
                await loadSheetData();
                openSheet(REGISTER_PAGE);
                enableLoginButton();
            } else {
                const registerNavTab = queryFirst('.js-register-select', loginPageNav);
                registerNavTab?.click();
            }
            // Handle Registration from Stylitics Widget Product Tile
            if (isMiniCartOpened && styliticsContainer && modalBody) {
                const styliticsElement = document.createElement('div');
                styliticsElement.id = 'styliticsWidgetProductId';
                styliticsElement.dataset.value = styliticsProductId;
                modalBody.appendChild(styliticsElement);
            }

            if (queryFirst('.add-to-loyalty-program-checkbox')) {
                $('form.registration').trigger('register:optin_load');
            }
        });
        $body.on('click', '.js-password-reset-link', async e => {
            e.preventDefault();
            const { target } = e;
            PREVIOUS_PAGE = target.closest('.existing-customer-sheet') ? EXISTING_CUSTOMER_PAGE : LOGIN_PAGE;
            await loadSheetData();
            openSheet(RESET_PASSWORD_PAGE);
        });
        $(accountSheet).on('click', '.modal-back', () => {
            setActivePage(PREVIOUS_PAGE);
        });
        $body.on('click', '.js-order-status-link', async e => {
            e.preventDefault();
            if (!fullLoginPage) {
                await loadSheetData();
                openSheet(TRACK_ORDER_PAGE);
            } else {
                const registerNavTab = queryFirst('.js-order-select', loginPageNav);
                registerNavTab?.click();
            }
        });
        $('#account-sheet')
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => {
                clearSheet();
            });
    }
};

formatPhoneNumber(registrationFormPhone);
enableLoginButton();
